export default "__VITE_ASSET__244d509a__"